export default __webpack_public_path__ + "static/media/iot_1.7d2d9c84.png";